<template>
  <div class="main_content admin">
    <!--<b-card no-body>-->
      <!--<b-tabs pills card vertical class="mobile_hack_tabs">-->
        <!--<b-tab title="用户管理" style="padding:20px 50px;min-height: 400px;">-->
          <!---->
        <!--</b-tab>-->
      <!--</b-tabs>-->
    <!--</b-card>-->
    <div class="filter_block" style="justify-content: space-between;">
      <div>
        <span>用户名：</span>
        <span style="display: inline-block;">
          <b-form-input v-model="param.username"></b-form-input>
        </span>
        <span>
          <button class="primary_btn" @click="getData(param)">查询</button>
        </span>
      </div>
      <div>
        <button style="margin-right: 15px;" class="secondary_btn" @click="batchToggleUsers('NORMAL')">批量启用</button>
        <button style="margin-right: 15px;" class="secondary_btn" @click="batchToggleUsers('DISABLED')">批量禁用</button>
        <button class="primary_btn" @click="newUserLine()">新建</button>
      </div>

    </div>

    <table class="table table-striped table-responsive-sm table-hover green_table">
      <thead>
      <tr>
        <th>
          <b-link href="#" style="font-size: 12px; padding-right: 10px;" @click="selectAll()">全选</b-link>
          <b-link href="#" style="font-size: 12px;" @click="shift()">反选</b-link>
        </th>
        <th scope="col">id</th>
        <th scope="col">用户名</th>
        <th scope="col">昵称</th>
        <th scope="col">密码</th>
        <th scope="col">角色</th>
        <th scope="col">状态</th>
        <th scope="col">操作</th>
      </tr>
      </thead>
      <tbody>
      <template v-for="(item, index) in data">
        <tr>
          <td>
            <b-form-checkbox @click.native.stop="selectedIdMap[item.id] = !selectedIdMap[item.id]" style="display: flex;"
                             v-model="selectedIdMap[item.id]">
            </b-form-checkbox>
          </td>
          <td>{{ item.id }}</td>
          <td>
            <b-form-input v-model="item.username" type="text"></b-form-input>
          </td>
          <td>
            <b-form-input v-model="item.name" type="text"></b-form-input>
          </td>
          <td>
            <div class="position-relative">
              <b-form-input v-model="item.password" :type="item.pwd_show"></b-form-input>
              <b-link @click="togglePwdShow(item)" class="position-absolute pwd-toggle-text">
                {{ getPwdToggleText(item) }}
              </b-link>
            </div>
          </td>
          <td>
            <b-form-select v-model="item.type" :options="userTypeOptions"></b-form-select>
          </td>
          <td>
            {{ userStatusMap[item.status] }}
          </td>
          <td>
            <div v-if="item.id">
              <b-link @click.stop="modify(item)" style="padding-right: 15px;">修改</b-link>
              <b-link @click.stop="toggleUsers([item.id], item.status === 'NORMAL' ? 'DISABLED' : 'NORMAL')">
                {{ item.status === 'NORMAL' ? '禁用' : '启用' }}
              </b-link>
            </div>
            <div v-else>
              <b-link @click.stop="newUser(item)" style="padding-right: 15px;">新增</b-link>
              <b-link @click.stop="data.splice(index, 1)" style="padding-right: 15px;">删除</b-link>
            </div>
          </td>
        </tr>
      </template>

      </tbody>
    </table>
  </div>
</template>
<script>
import { getUserTypes, getUsers, updateUser, toggleUsers, addUser } from '@/api/user'

export default {
  data () {
    return {
      param: {
        username: ''
      },
      userTypeOptions: [],
      userStatusMap: {
        NORMAL: '正常',
        DISABLED: '已禁用'
      },
      data: [],
      selectedIdMap: {}
    }
  },
  components: {
  },
  computed: {
    // selectedIds(){
    //   console.log('selectedIds --this.selectedOption',this.selectedOption)
    //   return this.selectedOption.map(v=>{ return v.id });
    // }
  },
  mounted () {
    getUserTypes().then(resp => {
      this.userTypeOptions = resp
      this.getData(this.param)
    })
  },
  methods: {
    selectAll () {
      this.data.forEach(item => {
        this.$set(this.selectedIdMap, item.id, true)
      })
    },
    shift () {
      this.data.forEach(item => {
        // this.selectedIdMap[item.id] = true
        this.$set(this.selectedIdMap, item.id, false)
      })
    },
    getData (params) {
      getUsers(params).then(resp => {
        this.data = resp
        this.data.forEach(item => {
          item.pwd_show = 'password'
        })
      }).catch(error => {
        console.error(error)
      })
    },
    modify (item) {
      updateUser({
        id: item.id,
        username: item.username,
        name: item.name,
        password: item.password,
        type: item.type
      }).then(resp => {
        if (this.respOk(resp)) {
          this.$toasted.global.pop_success('修改成功')
          this.getData(this.param)
        } else {
          this.$toasted.global.pop_error('操作失败:\n' + resp.msg)
        }
      }).catch(error => {
        this.$toasted.global.pop_error('修改失败\n' + error)
      })
    },
    toggleUsers (items, status) {
      if (!items.length) {
        this.$toasted.global.pop_error('请选择要操作的数据')
        return
      }
      toggleUsers({ ids: items, status: status }).then(resp => {
        if (this.respOk(resp)) {
          this.$toasted.global.pop_success('操作成功')
          this.getData(this.param)
        } else {
          this.$toasted.global.pop_error('操作失败:\n' + resp.msg)
        }
      }).catch(error => {
        this.$toasted.global.pop_error('操作失败:\n' + error)
      })
    },
    batchToggleUsers (status) {
      this.toggleUsers(Object.keys(this.selectedIdMap).filter(k => this.selectedIdMap[k]), status)
    },
    newUserLine () {
      // let currentSize = this.data.length
      this.data.unshift({
        id: undefined,
        username: '',
        name: '',
        password: '',
        pwd_show: 'password',
        type: 0,
        status: 'NORMAL'
      })
    },
    newUser (item) {
      addUser(item).then(resp => {
        if (this.respOk(resp)) {
          this.$toasted.global.pop_success('新增成功')
          this.getData(this.param)
        } else {
          this.$toasted.global.pop_error('操作失败:\n' + resp.msg)
        }
      }).catch(error => {
        this.$toasted.global.pop_error('操作失败:\n' + error)
      })
    },
    respOk (resp) {
      return resp.code === 200 && resp.bizCode === 200
    },
    togglePwdShow (item) {
      item.pwd_show = item.pwd_show === 'password' ? 'text' : 'password'
      this.$forceUpdate()
    },
    getPwdToggleText (item) {
      if (item.pwd_show === 'text') {
        return '隐藏'
      } else {
        return '显示'
      }
    }
  },
  watch: {}

}
</script>
<style lang="scss" scoped>
.pwd-toggle-text {
  right: 5px;
  top: 5px;
}
</style>
